import currencyCreateComponent from './currency.create.component';

export default angular
  .module('currency.create', [])
  .component('currencycreate', currencyCreateComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/create/index.js